import { Component, OnInit } from '@angular/core';
import { SystemSelectService } from './system-select.service';
import {
  SystemService,
  SystemAllocationStatusService
} from '../camtl.service';
import {
  ProgramService,
  SubZoneTitleService,
  BaseService
} from '../../mesc/mesc.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';



@Component({
  selector: 'camtl-system-select',
  templateUrl: './system-select.component.html',
  styleUrls: ['./system-select.component.scss']
})
export class SystemSelectComponent implements OnInit {
  selectedProgram: any = undefined;
  selectedZone: any = undefined;
  selectedSystem: any = undefined;

  constructor(
    public programService: ProgramService,
    public zoneService: SubZoneTitleService,
    public systemService: SystemService,
    public sss: SystemSelectService,
    public systemAllocationStatusService: SystemAllocationStatusService,
    private baseService: BaseService
  ) { }

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    this.sss.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        if (this.selectedSystem !== system) {
          this.selectedSystem = system;
          this.systemFilter = system.SystemNumber.toString();
          this.handleSystemFilter(this.systemFilter);
        }
      });

    Promise.all([
      this.systemService.read("/numbers?$filter=Status eq Active", true),
      this.programService.read("?$filter=IsActive eq true", true),
      this.zoneService.read("?$filter=IsActive eq true", true),
      this.systemAllocationStatusService.read(),
    ]).then(() => {
      this.sss.get();
      this.handleSystemChange(this.selectedSystem);
    })

    this.programService
      .subscribe(data => {
        data.map(x => x.Description = x.ProgramCode + ' - ' + x.ProgramDescription);
      });

    this.zoneService
      .subscribe(data => {
        data.map(x => x.Description = x.Zone + ' - ' + x.Title);
      })
  }

  ngOnChanges() {
    Promise.all([
      this.systemService.read("/numbers?$filter=Status eq Active", true),
      this.programService.read("?$filter=IsActive eq true", true),
      this.zoneService.read("?$filter=IsActive eq true", true),
    ]).then(() => this.handleSystemChange(this.selectedSystem))
  }


  /**
   * This method filters the dropdowns for System and Zone using the selected Program dataItem
   * @param value - Program dataItem
   */
  handleProgramChange(value: any) {
    this.selectedProgram = value;
    this.selectedZone = undefined;
    this.selectedSystem = undefined;
    this.handleSystemFilter(this.systemFilter);

    if (value) {
      let zones = this.zoneService.value
        .filter(x => this.sss.systemState.value.find(y => y.SubZoneTitleId === x.Id));
      this.sss.zoneState.next(zones);
    } else {
      this.sss.zoneState.next([]);
    }

  }


  /**
   * This method filters the dropdown for System using the selected Zone dataItem
   * @param value - Zone dataItem
   */
  handleZoneChange(value: any) {
    this.selectedZone = value;
    this.handleSystemFilter(this.systemFilter);
    if (value) {
    } else {
      this.handleProgramChange(this.selectedProgram);
      this.selectedSystem = undefined;
    }

  }


  /**
  * This method sets the dropdown values for Program and Zone using the selected System dataItem
  * @param value - System dataItem
   */
  handleSystemChange(value: any) {
    try {
      if (value) {
        this.selectedProgram = this.programService.value.find(x => x.Id === value.ProgramId);
        this.selectedZone = this.zoneService.value.find(x => x.Id === value.SubZoneTitleId);
        this.sss.zoneState.next([this.selectedZone]);

        let systemId = value.Id ? value.Id : value.SystemId;
        if (this.selectedSystem && this.selectedSystem.Id === systemId) return;
        this.baseService.read("camtl/System/" + systemId, true)
          .then(x => this.sss.add(x));
      } else {
        this.systemFilter = undefined;
        this.selectedSystem = undefined;
        this.selectedProgram = undefined;
        this.selectedZone = undefined;
        this.handleSystemFilter();
        this.handleProgramFilter();
        this.sss.zoneState.next([]);
        this.sss.add(undefined);
      }
    } catch (e) { }
  }

  handleProgramFilter = (check: string = undefined) => {
    let result: any[] = this.programService.value;
    if (check) result = result.filter(x => x.Description.toLowerCase().indexOf(check.toLowerCase()) === 0);
    this.sss.programState.next(result);
  }

  isShowSystemFilterInfo: boolean = true;
  systemFilter: string;

  handleSystemFilter = (check: string = undefined) => {
    this.systemFilter = check;
    let result: any[] = [];
    let systems = this.systemService.value;
    if (this.selectedProgram && systems.length > 0) {
      systems = systems.filter(x => x.ProgramId === this.selectedProgram.Id);
      result = systems;
    }
    if (this.selectedZone && systems.length > 0) {
      systems = systems.filter(x => x.SubZoneTitleId === this.selectedZone.Id);
      result = systems;
    }

    if (check && check !== "" && systems.length > 0) {
      result = systems.filter(x => {
        return x.SystemNumber.toString().toLowerCase()
          .indexOf(check.toLowerCase()) === 0;
      });
    }
    if (result.length > 0) {
      this.isShowSystemFilterInfo = (check === undefined || check == "" || result.length == 0);
      this.sss.systemState.next(result);
    }

  }

}

